var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "form",
      {
        ref: "form",
        attrs: { action: "" },
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.save.apply(null, arguments)
          },
        },
      },
      [
        _c("div", { staticClass: "row m-0" }, [
          _c("div", { staticClass: "col-md-4" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("label", { attrs: { for: "" } }, [_vm._v("Title поставщика")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.localSupplier.title,
                    expression: "localSupplier.title",
                  },
                ],
                staticClass: "form-control",
                attrs: { type: "text", required: "", placeholder: "Title" },
                domProps: { value: _vm.localSupplier.title },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.localSupplier, "title", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _c("p", { staticClass: "text-muted small_info" }, [
                _vm._v("короткое отображение в заказе препаратов"),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c("label", { attrs: { for: "" } }, [_vm._v("Login url")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.localSupplier.url,
                    expression: "localSupplier.url",
                  },
                ],
                staticClass: "form-control",
                attrs: { type: "text", placeholder: "Login url" },
                domProps: { value: _vm.localSupplier.url },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.localSupplier, "url", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _c("p", { staticClass: "text-muted small_info" }, [
                _vm._v("ссылка для авторизации"),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c("label", { attrs: { for: "" } }, [_vm._v("Посковый запрос")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.localSupplier.search_url,
                    expression: "localSupplier.search_url",
                  },
                ],
                staticClass: "form-control",
                attrs: { type: "text", placeholder: "Search url" },
                domProps: { value: _vm.localSupplier.search_url },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(
                      _vm.localSupplier,
                      "search_url",
                      $event.target.value
                    )
                  },
                },
              }),
              _vm._v(" "),
              _c("p", { staticClass: "text-muted small_info" }, [
                _vm._v("поисковый запрос $$$PZN$$$ для pzn"),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c("label", { attrs: { for: "" } }, [
                _vm._v("POST поле для поиска"),
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.localSupplier.search_post.post_fields.pzn,
                    expression: "localSupplier.search_post.post_fields.pzn",
                  },
                ],
                staticClass: "form-control",
                attrs: { type: "text", placeholder: "POST field" },
                domProps: {
                  value: _vm.localSupplier.search_post.post_fields.pzn,
                },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(
                      _vm.localSupplier.search_post.post_fields,
                      "pzn",
                      $event.target.value
                    )
                  },
                },
              }),
              _vm._v(" "),
              _c("p", { staticClass: "text-muted small_info" }, [
                _vm._v(
                  "если поисковый запрос POST, то каким полем передавать PZN"
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-4" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("label", { attrs: { for: "" } }, [_vm._v("Страна")]),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.localSupplier.country_id,
                      expression: "localSupplier.country_id",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { required: "" },
                  on: {
                    change: function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.localSupplier,
                        "country_id",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    },
                  },
                },
                [
                  _c("option", { attrs: { value: "", disabled: "" } }, [
                    _vm._v("Выберите страну"),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.$AllCountries, function (country) {
                    return _c("option", { domProps: { value: country.id } }, [
                      _vm._v(_vm._s(country.name)),
                    ])
                  }),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c("label", { attrs: { for: "" } }, [_vm._v("Login")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.localSupplier.login,
                    expression: "localSupplier.login",
                  },
                ],
                staticClass: "form-control",
                attrs: { type: "text", placeholder: "Login" },
                domProps: { value: _vm.localSupplier.login },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.localSupplier, "login", $event.target.value)
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c("label", { attrs: { for: "" } }, [_vm._v("Password")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.localSupplier.password,
                    expression: "localSupplier.password",
                  },
                ],
                staticClass: "form-control",
                attrs: { type: "text", placeholder: "Password" },
                domProps: { value: _vm.localSupplier.password },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.localSupplier, "password", $event.target.value)
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c("label", { attrs: { for: "" } }, [
                _vm._v("Максимальное количесво упаковок"),
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.localSupplier.max_qty,
                    expression: "localSupplier.max_qty",
                  },
                ],
                staticClass: "form-control",
                attrs: {
                  required: "",
                  type: "number",
                  placeholder: "Максимум на препарат",
                },
                domProps: { value: _vm.localSupplier.max_qty },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.localSupplier, "max_qty", $event.target.value)
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c("label", { attrs: { for: "" } }, [
                _vm._v("Скидка в % от суммы заказа"),
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.localSupplier.options.discount,
                    expression: "localSupplier.options.discount",
                  },
                ],
                staticClass: "form-control",
                attrs: {
                  required: "",
                  type: "number",
                  placeholder: "Скидка на заказ",
                },
                domProps: { value: _vm.localSupplier.options.discount },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(
                      _vm.localSupplier.options,
                      "discount",
                      $event.target.value
                    )
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-check" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.localSupplier.use_default,
                    expression: "localSupplier.use_default",
                  },
                ],
                staticClass: "form-check-input",
                attrs: { type: "checkbox", id: "ch_2" },
                domProps: {
                  checked: Array.isArray(_vm.localSupplier.use_default)
                    ? _vm._i(_vm.localSupplier.use_default, null) > -1
                    : _vm.localSupplier.use_default,
                },
                on: {
                  change: function ($event) {
                    var $$a = _vm.localSupplier.use_default,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 &&
                          _vm.$set(
                            _vm.localSupplier,
                            "use_default",
                            $$a.concat([$$v])
                          )
                      } else {
                        $$i > -1 &&
                          _vm.$set(
                            _vm.localSupplier,
                            "use_default",
                            $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                          )
                      }
                    } else {
                      _vm.$set(_vm.localSupplier, "use_default", $$c)
                    }
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                { staticClass: "form-check-label", attrs: { for: "ch_2" } },
                [_vm._v("Использовать по умолчанию для страны")]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-check" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.localSupplier.options.useBasket,
                    expression: "localSupplier.options.useBasket",
                  },
                ],
                staticClass: "form-check-input",
                attrs: { type: "checkbox", id: "ch_1" },
                domProps: {
                  checked: Array.isArray(_vm.localSupplier.options.useBasket)
                    ? _vm._i(_vm.localSupplier.options.useBasket, null) > -1
                    : _vm.localSupplier.options.useBasket,
                },
                on: {
                  change: function ($event) {
                    var $$a = _vm.localSupplier.options.useBasket,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 &&
                          _vm.$set(
                            _vm.localSupplier.options,
                            "useBasket",
                            $$a.concat([$$v])
                          )
                      } else {
                        $$i > -1 &&
                          _vm.$set(
                            _vm.localSupplier.options,
                            "useBasket",
                            $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                          )
                      }
                    } else {
                      _vm.$set(_vm.localSupplier.options, "useBasket", $$c)
                    }
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                { staticClass: "form-check-label", attrs: { for: "ch_1" } },
                [_vm._v("Использовать корзину для заказа")]
              ),
            ]),
            _vm._v(" "),
            _c("button", { staticClass: "hidden", attrs: { type: "submit" } }, [
              _vm._v("submit"),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-4" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("label", [_vm._v("Склад перемещения по умолчанию")]),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.localSupplier.options.default_store_id,
                      expression: "localSupplier.options.default_store_id",
                    },
                  ],
                  staticClass: "form-control",
                  on: {
                    change: function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.localSupplier.options,
                        "default_store_id",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    },
                  },
                },
                [
                  _c("option", { attrs: { value: "0", disabled: "" } }, [
                    _vm._v("Выберите склад"),
                  ]),
                  _vm._v(" "),
                  _vm._l(
                    Object.values(_vm.$AllStores).filter(
                      (s) => s.is_active && s.id !== 1
                    ),
                    function (s) {
                      return _c("option", { domProps: { value: s.id } }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(s.title) +
                            "\n            "
                        ),
                      ])
                    }
                  ),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c("label", [_vm._v("Настройка расходов на доставку")]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-xs btn-default",
                    attrs: { type: "button" },
                    on: { click: _vm.addDeliveryExpenses },
                  },
                  [_vm._v("добавить просчет")]
                ),
                _vm._v(" "),
                _vm._l(
                  _vm.localSupplier.options.delivery_expenses,
                  function (e, i) {
                    return _c("div", { key: i, staticClass: "input-group" }, [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: e.type,
                              expression: "e.type",
                            },
                          ],
                          staticClass: "form-control",
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                e,
                                "type",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            },
                          },
                        },
                        [
                          _c(
                            "option",
                            { attrs: { value: "0", disabled: "" } },
                            [_vm._v("Выберите тип")]
                          ),
                          _vm._v(" "),
                          _vm._l(
                            _vm.$platformConstants
                              .supplierDeliveryExpensesTypes,
                            function (t) {
                              return _c(
                                "option",
                                { domProps: { value: t.alias } },
                                [_vm._v(_vm._s(t.title) + "\n              ")]
                              )
                            }
                          ),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      ["byVolume", "byWeight"].includes(e.type)
                        ? _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: e.unit,
                                expression: "e.unit",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: { type: "text", placeholder: "Количество" },
                            domProps: { value: e.unit },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(e, "unit", $event.target.value)
                              },
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: e.amount,
                            expression: "e.amount",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text", placeholder: "Сумма" },
                        domProps: { value: e.amount },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(e, "amount", $event.target.value)
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: e.currency_id,
                              expression: "e.currency_id",
                            },
                          ],
                          staticClass: "form-control",
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                e,
                                "currency_id",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            },
                          },
                        },
                        [
                          _c(
                            "option",
                            { attrs: { value: "0", disabled: "" } },
                            [_vm._v("Выберите валюту")]
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.$AllCurrencies, function (c) {
                            return _c("option", { domProps: { value: c.id } }, [
                              _vm._v(_vm._s(c.currency)),
                            ])
                          }),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "input-group-append" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-outline-danger",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.removeExpenses(i)
                              },
                            },
                          },
                          [_c("i", { staticClass: "icon-fa icon-fa-trash" })]
                        ),
                      ]),
                    ])
                  }
                ),
              ],
              2
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("pulse-loader", {
          staticClass: "text-center mt-2",
          attrs: { loading: _vm.loading, color: _vm.$constants.LOADING_COLOR },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }